module.exports = __webpack_public_path__ + "media/src/images/progress/dentals_7-e7c05afb675ed61dd94caeafe1f06fec.jpg";